


document.addEventListener('DOMContentLoaded', () => {


  // Get all the anchor elements within the list
  const tabLinks = document.querySelectorAll('.o-tabs__tab');
  const tabSections = document.querySelectorAll('.o-tabs__section');
  // Attach click event listeners to each anchor element

  for ( let i = 0; i < tabLinks.length; i++ ) {

    tabLinks[ i ].addEventListener('click', function( e ) {
      e.preventDefault();
      tabLinks.forEach( ( element ) => {// eslint-disable-line arrow-parens
        element.classList.remove( 'j-active' );
      } );
      tabSections.forEach( ( element ) => {// eslint-disable-line arrow-parens
        element.classList.remove( 'j-active' );
      } );
      tabLinks[ i ].classList.add( 'j-active' );
      tabSections[ i ].classList.add( 'j-active' );
    } );

  }

  // accordion
  const accordionLinks = document.querySelectorAll('.o-view__KAS--accordion h3');
  const accordionSection = document.querySelectorAll('.o-view__KAS--month');

  for ( let i = 0; i < accordionLinks.length; i++ ) {
    accordionSection[ 0 ].classList.add( 'j-active' );
    accordionLinks[ 0 ].classList.add( 'j-active' );
    accordionLinks[ i ].addEventListener('click', function( e ) {
      e.preventDefault();

      accordionLinks[ i ].classList.toggle( 'j-active' );
      accordionSection[ i ].classList.toggle( 'j-active' );
    } );
  }
});
